<script setup lang="ts">
import { UK_TOOLS } from '~/constants/ukTools'

/**
 * "For UK applicants": the Civil Service and NHS writers, on the English
 * homepage only (the pages exist in English alone). Plain links in the server
 * HTML, so the homepage passes them on to search engines as well as people.
 */
const { civilServicePrice, nhsStatementPrice } = usePremiumPlans()
const priceOf = (id: string) => (id === 'civil-service' ? civilServicePrice : nhsStatementPrice)
</script>

<template>
  <section class="sofax bg-white dark:bg-gray-950">
    <div class="section-space">
      <div class="shell">
        <SofaxSectionHeading
          eyebrow="For UK applicants"
          title="Applying for the Civil Service or the NHS?"
          text="Public-sector applications are scored on statements, not on your CV alone. Paste the advert and your CV, answer a few questions, and get statements written to the advert's criteria and word limits, from your own experience."
          width="max-w-3xl"
        />
        <ul class="mx-auto grid max-w-5xl gap-6 md:grid-cols-2">
          <li v-for="tool in UK_TOOLS" :key="tool.id">
            <NuxtLink
              :to="tool.path"
              class="group flex h-full flex-col rounded-[0.9375rem] border border-line bg-surface p-[1.875rem] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lift dark:border-gray-700 dark:bg-gray-800"
            >
              <span class="inline-flex size-14 items-center justify-center rounded-[0.625rem] bg-accent-soft/40 text-2xl text-accent-strong dark:text-accent-soft" aria-hidden="true">
                <i class="bi" :class="tool.icon" />
              </span>
              <span class="mt-6 font-title !text-2xl font-bold -tracking-[0.5px] !text-ink dark:!text-white">{{ tool.title }}</span>
              <span class="mt-3 flex-1 !text-base">{{ tool.description }}</span>
              <span class="mt-6 flex flex-wrap items-center justify-between gap-3">
                <span class="!text-sm !text-muted dark:!text-gray-400">Free preview · {{ priceOf(tool.id) }} per advert</span>
                <SofaxArrowLink as="span" label="Start with the advert" />
              </span>
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
